<mat-expansion-panel #panelRef class="operation-panel" (opened)="loadProofsForOperation(operation)" [class.dragging]="isDragging">
  <mat-expansion-panel-header class="operation-header">
    <mat-panel-title class="operation-title-container">
      <mat-icon *ngIf="isPeriodModeEnabled && isEditable" class="drag-handle" [matTooltip]="'solution_operation_drag_to_assign' | translate" draggable="true" (dragstart)="onDragStart($event)" (dragend)="onDragEnd()">drag_indicator</mat-icon>

      <span class="operation-name">{{ operation.displayName }}</span>

      <span *ngIf="needsAdjustment" class="operation-to-adjust" [matTooltip]="'solution_operation_to_adjust_hint' | translate">{{ 'solution_operation_to_adjust' | translate }}</span>

      <button
        *ngIf="isPeriodModeEnabled && isEditable"
        mat-icon-button
        [matMenuTriggerFor]="periodAssignmentMenu"
        class="period-assign-menu"
        (click)="$event.stopPropagation()"
        (menuOpened)="onPeriodMenuOpened()"
        (menuClosed)="onPeriodMenuClosed()"
        [matTooltip]="'solution_operation_assign_to_period' | translate">
        <mat-icon>folder_open</mat-icon>
      </button>
      <mat-menu #periodAssignmentMenu="matMenu">
        <button mat-menu-item (click)="changePeriod(undefined)">
          <mat-icon>folder_off</mat-icon>
          <span>{{ 'solution_operation_unassign' | translate }}</span>
        </button>
        <mat-divider *ngIf="allPeriods.length > 0"></mat-divider>
        <div mat-menu-item *ngFor="let period of allPeriods" (click)="$event.stopPropagation()">
          <mat-checkbox [checked]="isPeriodTicked(period)" (change)="togglePeriod(period, $event.checked)">
            {{ period.name }}
          </mat-checkbox>
        </div>
      </mat-menu>

      <button *ngIf="canRenameCopy" mat-icon-button class="period-assign-menu" (click)="$event.stopPropagation(); renameCopy()" [matTooltip]="'solution_operation_rename_copy' | translate">
        <mat-icon>edit</mat-icon>
      </button>

      <button *ngIf="isEditable && isCopy" mat-icon-button class="period-assign-menu" (click)="$event.stopPropagation(); requestDelete()" [matTooltip]="'solution_operation_delete_copy' | translate">
        <mat-icon>delete_outline</mat-icon>
      </button>
    </mat-panel-title>

    <mat-panel-description class="operation-info-container">
      <div class="operation-total-badge">
        {{ 'solution_operation_total' | translate }} <strong>{{ getFormattedOperationValue(operation) }}</strong> {{ activeIndicator?.workUnityDisplayShortName }}
      </div>
    </mat-panel-description>
  </mat-expansion-panel-header>

  <div class="operation-content">
    <div class="operation-meta-row">
      <div class="meta-item">
        <span class="label">{{ 'solution_operation_creator' | translate }}</span>
        <span class="value">{{ operation.creator || '-' }}</span>
      </div>
      <div class="meta-item">
        <span class="label">{{ 'solution_operation_operation_type' | translate }}</span>
        <span class="value">{{ getOperationTypeDisplayName(operation.type) || '-' }}</span>
      </div>
    </div>

    <div class="row" *ngIf="isEditable">
      <div class="col">
        <mat-form-field>
          <mat-label>{{ 'solution_operation_description' | translate }}</mat-label>
          <textarea type="text" rows="3" [(ngModel)]="operation.description" [ngModelOptions]="{ standalone: true }" (blur)="updateOperationDescription()" matInput></textarea>
        </mat-form-field>
      </div>
    </div>

    <div class="operation-description" *ngIf="operation.description && !isEditable">
      {{ operation.description }}
    </div>

    <mat-divider class="mt-3 mb-3"></mat-divider>

    <!-- Shared table cell templates -->
    <ng-template #productStatusCell let-row>
      <badge-statut [item]="row.item" [itemType]="'operation-product'"></badge-statut>
    </ng-template>

    <ng-template #productNameCell let-row>
      <editable-field [disabled]="!isEditable" (onClick)="changeProduct(row.item, operation, row.type)" [showCustomContent]="false">
        <span>{{ row.item.displayName }} [{{ row.item.productCode }}]</span>
      </editable-field>
    </ng-template>

    <ng-template #productTransportCell let-row>
      <ng-container *ngIf="row.item.pipeProduct || row.item.cableProduct; else productTransportDefault">
        <mat-expansion-panel class="compact-expansion-panel" hideToggle [expanded]="isProductPanelExpanded(row.item.operationCompositionId)">
          <mat-expansion-panel-header (click)="toggleProductPanel(row.item.operationCompositionId)">
            <mat-icon>{{ isProductPanelExpanded(row.item.operationCompositionId) ? 'expand_more' : 'chevron_right' }}</mat-icon>
            <span>{{ row.item.transportName || ('common_no_transport' | translate) }}</span>
          </mat-expansion-panel-header>
          <mat-list dense>
            <mat-list-item>{{ 'solution_operation_production_site' | translate }} {{ row.item.productionSite || '-' }}</mat-list-item>
          </mat-list>
        </mat-expansion-panel>
      </ng-container>
      <ng-template #productTransportDefault>
        <editable-field [disabled]="!isEditable" (onClick)="registerFieldForClose($event)">
          <span>{{ row.item.transportName || ('common_no_transport' | translate) }}</span>
          <div slot="dialog-content">
            <mat-form-field>
              <mat-label>{{ 'common_field_transport' | translate }}</mat-label>
              <mat-select name="transportName" [value]="row.item.transportId || '0'" (selectionChange)="updateProductField({ transportId: $event.value, isMultimodal: false }, row.item, operation, row.type)">
                <mat-option value="0">{{ 'common_no_transport' | translate }}</mat-option>
                <mat-option *ngFor="let t of allTransports" [value]="t.resourceId">{{ t.displayName }}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </editable-field>
      </ng-template>
    </ng-template>

    <ng-template #productEnergyCell let-row>
      <ng-container *ngIf="!row.item.isMultimodal && row.item.transportId && row.item.transportId !== '0'">
        <editable-field [disabled]="!isEditable" (onClick)="registerFieldForClose($event)">
          <span>{{ row.item.energyName || ('common_no_energy' | translate) }}</span>
          <div slot="dialog-content">
            <mat-form-field>
              <mat-label>{{ 'common_field_energy' | translate }}</mat-label>
              <mat-select name="energyName" [value]="row.item.energyId || '0'" (selectionChange)="updateProductField({ energyId: $event.value }, row.item, operation, row.type)">
                <mat-option value="0">{{ 'common_no_energy' | translate }}</mat-option>
                <mat-option *ngFor="let e of allEnergies" [value]="e.resourceId">{{ e.displayName }}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </editable-field>
      </ng-container>
    </ng-template>

    <ng-template #productMultimodalCell let-row>
      <div class="text-center">
        <button mat-icon-button (click)="addOrEditMultimodalTransport(row.item, operation, row.type)" *ngIf="isEditable" [matTooltip]="'solution_operation_select_multimodal' | translate">
          <mat-icon [class.active-icon]="row.item.isMultimodal">zoom_in</mat-icon>
        </button>
        <mat-icon *ngIf="!isEditable && row.item.isMultimodal">zoom_in</mat-icon>
        <button mat-icon-button (click)="removeMultimodalTransport(row.item, operation, row.type)" *ngIf="isEditable && row.item.isMultimodal" [matTooltip]="'solution_operation_remove_multimodal' | translate">
          <mat-icon>delete_outline</mat-icon>
        </button>
      </div>
    </ng-template>

    <ng-template #productDistanceCell let-row>
      <ng-container *ngIf="!row.item.isMultimodal && row.item.transportId && row.item.transportId !== '0'">
        <editable-field [disabled]="!isEditable" (onClick)="registerFieldForClose($event)">
          {{ row.item.distance ? row.item.distance : 0 }}
          <div slot="dialog-content">
            <mat-form-field>
              <mat-label>{{ 'common_field_distance' | translate }}</mat-label>
              <input
                matInput
                type="number"
                [(ngModel)]="row.item.distance"
                [ngModelOptions]="{ standalone: true }"
                name="distance"
                min="0"
                step="0.1"
                cdkFocusInitial
                required
                (blur)="updateProductField({ distance: getInputValue($event) }, row.item, operation, row.type)" />
            </mat-form-field>
          </div>
        </editable-field>
      </ng-container>
    </ng-template>

    <ng-template #productDoubleFreightCell let-row>
      <div class="text-center">
        <ng-container *ngIf="!row.item.isMultimodal">
          <mat-checkbox [checked]="!!row.item.isDoubleFreight" [disabled]="!isEditable" (change)="toggleDoubleFreight(row.item, operation, row.type)" class="small-checkbox"></mat-checkbox>
        </ng-container>
      </div>
    </ng-template>

    <ng-template #productUnitCell let-row>
      <span>{{ row.item.workUnit }}</span>
    </ng-template>

    <ng-template #productQuantityCell let-row>
      <ng-container *ngIf="row.item.pipeProduct || row.item.cableProduct; else productQuantityDefault">
        <mat-expansion-panel class="compact-expansion-panel" hideToggle [expanded]="isProductPanelExpanded(row.item.operationCompositionId)">
          <mat-expansion-panel-header (click)="toggleProductPanel(row.item.operationCompositionId)">
            <mat-icon>{{ isProductPanelExpanded(row.item.operationCompositionId) ? 'expand_more' : 'chevron_right' }}</mat-icon>
            <strong>{{ row.item.quantity }}</strong>
          </mat-expansion-panel-header>
          <div class="quantity-details">
            <div *ngIf="row.item.pipeProduct">
              <div class="quantity-detail-row">
                <span class="detail-label">{{ 'solution_operation_dn_mm' | translate }}</span>
                <span class="detail-value">{{ row.item.diameter || '-' }}</span>
              </div>
              <div class="quantity-detail-row">
                <span class="detail-label">{{ 'solution_operation_unit_weight' | translate }}</span>
                <span class="detail-value">{{ row.item.unitWeight || '-' }}</span>
              </div>
            </div>
            <div *ngIf="row.item.cableProduct">
              <div class="quantity-detail-row">
                <span class="detail-label">{{ 'solution_operation_section' | translate }}</span>
                <span class="detail-value">{{ row.item.section || '-' }}</span>
              </div>
              <div class="quantity-detail-row">
                <span class="detail-label">{{ 'solution_operation_nb_conductors' | translate }}</span>
                <span class="detail-value">{{ row.item.nbConductors || '-' }}</span>
              </div>
            </div>
          </div>
        </mat-expansion-panel>
      </ng-container>
      <ng-template #productQuantityDefault>
        <editable-field [disabled]="!isEditable" (onClick)="registerFieldForClose($event)">
          <strong>{{ row.item.quantity }}</strong>
          <div slot="dialog-content">
            <mat-form-field>
              <mat-label>{{ 'common_field_quantity' | translate }}</mat-label>
              <input
                matInput
                type="number"
                [(ngModel)]="row.item.quantity"
                [ngModelOptions]="{ standalone: true }"
                name="quantity"
                min="0"
                step="any"
                cdkFocusInitial
                required
                (blur)="updateProductField({ quantity: getInputValue($event) }, row.item, operation, row.type)" />
            </mat-form-field>
          </div>
        </editable-field>
      </ng-template>
    </ng-template>

    <ng-template #productProofCell let-row>
      <div class="proof-container" *ngIf="isEditable">
        <button mat-icon-button (click)="addProof(row.item, operation)" [matTooltip]="'solution_operation_add_modify_proof' | translate">
          <mat-icon [class.has-proof]="getProofCountForItem(row.item, operation) > 0">note_add</mat-icon>
        </button>
        <span class="proof-count" *ngIf="getProofCountForItem(row.item, operation) > 0"> ({{ getProofCountForItem(row.item, operation) }}) </span>
      </div>
      <div *ngIf="!isEditable && getProofCountForItem(row.item, operation) > 0" class="proof-container">
        <mat-icon class="pj-icon has-proof" [matTooltip]="'solution_operation_attachment_available' | translate">description</mat-icon>
        <span class="proof-count">({{ getProofCountForItem(row.item, operation) }})</span>
      </div>
    </ng-template>

    <ng-template #productActionsCell let-row>
      <div class="actions-cell" *ngIf="isEditable">
        <mat-icon class="action-icon" (click)="editProduct(row.item, row.type, operation)">edit</mat-icon>
        <mat-icon class="action-icon delete" (click)="deleteProduct(row.item, row.type, operation)">delete_outline</mat-icon>
      </div>
    </ng-template>

    <ng-template #vehicleStatusCell let-row>
      <badge-statut [item]="row.item" [itemType]="'operation-product'"></badge-statut>
    </ng-template>

    <ng-template #vehicleNameCell let-row>
      <ng-container [ngSwitch]="row.kind">
        <ng-container *ngSwitchCase="'dredge'">
          <span>{{ row.item.displayName }}</span>
        </ng-container>
        <ng-container *ngSwitchCase="'tunnel'">
          <span>{{ row.item.displayName }}</span>
        </ng-container>
        <ng-container *ngSwitchDefault>
          <ng-container *ngIf="row.item.isAtelier && row.item.atelierEngins && row.item.atelierEngins.length > 0; else defaultVehicleCell">
            <mat-expansion-panel class="compact-expansion-panel" hideToggle [expanded]="isVehiclePanelExpanded(row.item.vehicleId)">
              <mat-expansion-panel-header (click)="toggleVehiclePanel(row.item.vehicleId)">
                <mat-icon>{{ isVehiclePanelExpanded(row.item.vehicleId) ? 'expand_more' : 'chevron_right' }}</mat-icon>
                <span>{{ row.item.displayName }}</span>
              </mat-expansion-panel-header>
              <mat-list dense>
                <mat-list-item *ngFor="let engin of row.item.atelierEngins">
                  <mat-icon mat-list-icon class="sub-item-icon">subdirectory_arrow_right</mat-icon>
                  {{ engin.quantity }}x {{ engin.displayName }} — {{ engin.energyName ? engin.energyName : ('common_other_energy' | translate) }}
                </mat-list-item>
              </mat-list>
            </mat-expansion-panel>
          </ng-container>
          <ng-template #defaultVehicleCell>
            <editable-field [disabled]="!isEditable" (onClick)="changeVehicle(row.item, operation)" [showCustomContent]="false">
              <span>{{ row.item.displayName }}</span>
            </editable-field>
          </ng-template>
        </ng-container>
      </ng-container>
    </ng-template>

    <ng-template #vehicleEnergyCell let-row>
      <ng-container [ngSwitch]="row.kind">
        <ng-container *ngSwitchCase="'dredge'">
          <span>{{ row.item?.selectedFuelName }}</span>
        </ng-container>
        <ng-container *ngSwitchCase="'tunnel'">
          <editable-field [disabled]="!isEditable">
            {{ row.item?.energyName ? row.item?.energyName : ('common_other_energy' | translate) }}
            <div slot="dialog-content">
              <mat-form-field>
                <mat-label>{{ 'project_col_energy' | translate }}</mat-label>
                <mat-select name="tunnelEnergy" [value]="row.item.selectedFuel || EMPTY_GUID" (selectionChange)="updateTunnelerFuel(row.item, operation, $event.value)">
                  <mat-option [value]="EMPTY_GUID">{{ defaultTunnelerFuelName() || ('common_other_energy' | translate) }}</mat-option>
                  <mat-option *ngFor="let e of vehicleEnergies" [value]="e?.resourceId">{{ e?.displayName }}</mat-option>
                </mat-select>
              </mat-form-field>
            </div>
          </editable-field>
        </ng-container>
        <ng-container *ngSwitchDefault>
          <ng-container *ngIf="!row.item.isAtelier">
            <editable-field [disabled]="!isEditable" [href]="SiteMapUrl.MenuEnergie + '/vehicle/' + row.item.energyId" [target]="'_blank'" [linkDisabled]="!row.item.energyId || row.item.energyId === EMPTY_GUID">
              {{ row.item?.energyName ? row.item?.energyName : ('common_other_energy' | translate) }}
              <div slot="dialog-content">
                <mat-form-field>
                  <mat-label>{{ 'project_col_energy' | translate }}</mat-label>
                  <mat-select name="vehicleEnergyName" [value]="row.item.energyId || EMPTY_GUID" (selectionChange)="updateVehicleField({ energyId: $event.value }, row.item, operation)">
                    <mat-option [value]="EMPTY_GUID">{{ 'common_other_energy' | translate }}</mat-option>
                    <mat-option *ngFor="let e of vehicleEnergies" [value]="e?.resourceId">{{ e?.displayName }}</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
            </editable-field>
          </ng-container>
        </ng-container>
      </ng-container>
    </ng-template>

    <ng-template #vehicleQuantityCell let-row>
      <ng-container [ngSwitch]="row.kind">
        <ng-container *ngSwitchCase="'dredge'">
          <editable-field [disabled]="!isEditable" (onClick)="editDredgingEquipment(row.item, operation)" [showCustomContent]="false">
            <strong>{{ getDredgeQuantityDisplay(row.item.execPhaseDuration) }}</strong>
          </editable-field>
        </ng-container>
        <ng-container *ngSwitchCase="'tunnel'">
          <editable-field [disabled]="!isEditable" (onClick)="editTunnelingEquipment(row.item, operation)" [showCustomContent]="false">
            <strong>{{ displayAsDay ? row.item.presenceDuration || 0 : getHoursFromDay(row.item.presenceDuration) }}</strong>
          </editable-field>
        </ng-container>
        <ng-container *ngSwitchDefault>
          <editable-field [disabled]="!isEditable" (onClick)="editVehicleDetails(row.item, operation)" [showCustomContent]="false">
            <strong>{{ displayAsDay ? row.item.quantity : getHoursFromDay(row.item.quantity) }}</strong>
          </editable-field>
        </ng-container>
      </ng-container>
    </ng-template>

    <ng-template #vehicleProofCell let-row>
      <ng-container [ngSwitch]="row.kind">
        <ng-container *ngSwitchCase="'dredge'">
          <div class="proof-container" *ngIf="isEditable">
            <input type="file" #dredgeProofInput hidden (change)="uploadDredgeOrTunnelProof(row.item, operation, 'dredge', $event)" />
            <button mat-icon-button (click)="dredgeProofInput.click()" [matTooltip]="'solution_operation_add_modify_proof' | translate">
              <mat-icon [class.has-proof]="!!row.item.fileName">note_add</mat-icon>
            </button>
          </div>
          <div *ngIf="!isEditable && row.item.fileName" class="proof-container">
            <mat-icon class="pj-icon has-proof" [matTooltip]="'solution_operation_attachment_available' | translate">description</mat-icon>
          </div>
        </ng-container>
        <ng-container *ngSwitchCase="'tunnel'">
          <div class="proof-container" *ngIf="isEditable">
            <input type="file" #tunnelProofInput hidden (change)="uploadDredgeOrTunnelProof(row.item, operation, 'tunnel', $event)" />
            <button mat-icon-button (click)="tunnelProofInput.click()" [matTooltip]="'solution_operation_add_modify_proof' | translate">
              <mat-icon [class.has-proof]="!!row.item.fileName">note_add</mat-icon>
            </button>
          </div>
          <div *ngIf="!isEditable && row.item.fileName" class="proof-container">
            <mat-icon class="pj-icon has-proof" [matTooltip]="'solution_operation_attachment_available' | translate">description</mat-icon>
          </div>
        </ng-container>
        <ng-container *ngSwitchDefault>
          <div class="proof-container" *ngIf="isEditable">
            <button mat-icon-button (click)="addProof(row.item, operation)" [matTooltip]="'solution_operation_add_modify_proof' | translate">
              <mat-icon [class.has-proof]="getProofCountForItem(row.item, operation) > 0">note_add</mat-icon>
            </button>
            <span class="proof-count" *ngIf="getProofCountForItem(row.item, operation) > 0"> ({{ getProofCountForItem(row.item, operation) }}) </span>
          </div>
          <div *ngIf="!isEditable && getProofCountForItem(row.item, operation) > 0" class="proof-container">
            <mat-icon class="pj-icon has-proof" [matTooltip]="'solution_operation_attachment_available' | translate">description</mat-icon>
            <span class="proof-count">({{ getProofCountForItem(row.item, operation) }})</span>
          </div>
        </ng-container>
      </ng-container>
    </ng-template>

    <ng-template #vehicleActionsCell let-row>
      <div class="actions-cell" *ngIf="isEditable">
        <ng-container [ngSwitch]="row.kind">
          <ng-container *ngSwitchCase="'dredge'">
            <mat-icon class="action-icon edit" (click)="editDredgingEquipment(row.item, operation)">edit</mat-icon>
            <mat-icon class="action-icon delete" (click)="deleteDredgingEquipment(row.item, operation)">delete_outline</mat-icon>
          </ng-container>
          <ng-container *ngSwitchCase="'tunnel'">
            <mat-icon class="action-icon edit" (click)="editTunnelingEquipment(row.item, operation)">edit</mat-icon>
            <mat-icon class="action-icon delete" (click)="deleteTunnelingEquipment(row.item, operation)">delete_outline</mat-icon>
          </ng-container>
          <ng-container *ngSwitchDefault>
            <mat-icon class="action-icon edit" (click)="editVehicleDetails(row.item, operation)" [matTooltip]="'solution_operation_edit_engine_details' | translate">edit</mat-icon>
            <mat-icon class="action-icon delete" (click)="deleteVehicle(row.item, operation)">delete_outline</mat-icon>
          </ng-container>
        </ng-container>
      </div>
    </ng-template>

    <ng-template #vehicleQuantityHeader>
      <div class="quantity-header">
        <mat-select [(ngModel)]="displayAsDay" class="compact-select">
          <mat-option [value]="true">{{ 'solution_operation_qty_days' | translate }}</mat-option>
          <mat-option [value]="false">{{ 'solution_operation_qty_hours' | translate }}</mat-option>
        </mat-select>
      </div>
    </ng-template>

    <ng-template #proofCommentCell let-row>
      <ng-container *ngIf="row.proof.comment">
        <span>
          {{ isCommentExpanded(row.proof.id) ? row.proof.comment : (row.proof.comment | slice: 0 : commentCharLimit) }}
          <ng-container *ngIf="!isCommentExpanded(row.proof.id) && row.proof.comment.length > commentCharLimit">...</ng-container>
        </span>
        <a *ngIf="row.proof.comment.length > commentCharLimit" (click)="toggleCommentExpansion(row.proof.id)">
          {{ isCommentExpanded(row.proof.id) ? ('solution_operation_see_less' | translate) : ('solution_operation_see_more' | translate) }}
        </a>
      </ng-container>
    </ng-template>

    <ng-template #proofFileNameCell let-row>
      <ng-container *ngIf="row.proof.fileName">
        <a *ngIf="!row.proof.syntheticKind; else syntheticFileName" [href]="getProofFileUrl(row.proof)" target="_blank">
          {{ row.proof.fileName }}
        </a>
        <ng-template #syntheticFileName>
          <a [href]="getDredgeOrTunnelProofUrl(row.proof)" target="_blank">{{ row.proof.fileName }}</a>
        </ng-template>
      </ng-container>
    </ng-template>

    <ng-template #proofActionsCell let-row>
      <div class="actions-cell" *ngIf="isEditable">
        <ng-container *ngIf="row.proof.syntheticKind; else standardProofActions">
          <mat-icon class="action-icon edit" (click)="editSyntheticProof(row.proof, operation)">edit</mat-icon>
          <mat-icon class="action-icon delete" (click)="deleteSyntheticProof(row.proof, operation)">delete_outline</mat-icon>
        </ng-container>
        <ng-template #standardProofActions>
          <mat-icon class="action-icon edit" (click)="editProof(row.proof, operation)">edit</mat-icon>
          <mat-icon class="action-icon delete" (click)="deleteProof(row.proof, operation)">delete_outline</mat-icon>
        </ng-template>
      </div>
    </ng-template>

    <mat-tab-group class="resource-tabs green-tabs" animationDuration="0ms">
      <mat-tab [label]="'project_tab_input_products' | translate">
        <ng-container *ngIf="inputProductRows.length > 0; else noInputRows">
          <div class="operation-table-wrapper">
            <app-table
              class="operation-table"
              [columns]="productColumns"
              [rows]="inputProductRows"
              [customCellTemplates]="{
                status: productStatusCell,
                product: productNameCell,
                transport: productTransportCell,
                energy: productEnergyCell,
                multimodal: productMultimodalCell,
                distance: productDistanceCell,
                doubleFreight: productDoubleFreightCell,
                unit: productUnitCell,
                quantity: productQuantityCell,
                proofs: productProofCell,
                actions: productActionsCell
              }">
            </app-table>
          </div>
        </ng-container>
        <ng-template #noInputRows>
          <div class="operation-table-wrapper">
            <div class="empty-table">{{ 'solution_operation_no_input_product' | translate }}</div>
          </div>
        </ng-template>
        <div class="add-resource-row" *ngIf="isEditable">
          <button mat-button color="accent" (click)="addProduct('input', operation)"><mat-icon>add_circle</mat-icon> {{ 'solution_operation_add_product' | translate }}</button>
        </div>
      </mat-tab>

      <mat-tab [label]="'project_tab_output_products' | translate">
        <ng-container *ngIf="outputProductRows.length > 0; else noOutputRows">
          <div class="operation-table-wrapper">
            <app-table
              class="operation-table"
              [columns]="productColumns"
              [rows]="outputProductRows"
              [customCellTemplates]="{
                status: productStatusCell,
                product: productNameCell,
                transport: productTransportCell,
                energy: productEnergyCell,
                multimodal: productMultimodalCell,
                distance: productDistanceCell,
                doubleFreight: productDoubleFreightCell,
                unit: productUnitCell,
                quantity: productQuantityCell,
                proofs: productProofCell,
                actions: productActionsCell
              }">
            </app-table>
          </div>
        </ng-container>
        <ng-template #noOutputRows>
          <div class="operation-table-wrapper">
            <div class="empty-table">{{ 'solution_operation_no_output_product' | translate }}</div>
          </div>
        </ng-template>
        <div class="add-resource-row" *ngIf="isEditable">
          <button mat-button color="accent" (click)="addProduct('output', operation)"><mat-icon>add_circle</mat-icon> {{ 'solution_operation_add_product' | translate }}</button>
        </div>
      </mat-tab>

      <mat-tab [label]="'project_tab_engines' | translate">
        <ng-container *ngIf="vehicleRows.length > 0; else noVehicleRows">
          <div class="operation-table-wrapper">
            <app-table
              class="operation-table"
              [columns]="vehicleColumns"
              [rows]="vehicleRows"
              [customCellTemplates]="{
                status: vehicleStatusCell,
                vehicle: vehicleNameCell,
                energy: vehicleEnergyCell,
                quantity: vehicleQuantityCell,
                proofs: vehicleProofCell,
                actions: vehicleActionsCell
              }"
              [customHeaderTemplates]="{ quantity: vehicleQuantityHeader }">
            </app-table>
          </div>
        </ng-container>
        <ng-template #noVehicleRows>
          <div class="operation-table-wrapper">
            <div class="empty-table">{{ 'solution_operation_no_engine' | translate }}</div>
          </div>
        </ng-template>
        <div class="add-resource-row" *ngIf="isEditable">
          <button mat-button color="accent" (click)="addVehicle(operation)"><mat-icon>add_circle</mat-icon> {{ 'solution_operation_add_engine' | translate }}</button>
        </div>
      </mat-tab>

      <mat-tab [label]="'solution_operation_proofs' | translate" *ngIf="isEditable">
        <div class="justificative-filters" [formGroup]="proofFilterForm">
          <mat-form-field appearance="outline" class="filter-field">
            <mat-label>{{ 'solution_operation_search_by_filename' | translate }}</mat-label>
            <input matInput formControlName="fileNameSearch" />
            <mat-icon matSuffix>search</mat-icon>
          </mat-form-field>

          <mat-form-field appearance="outline" class="filter-field">
            <mat-label>{{ 'solution_operation_filter_by_resource' | translate }}</mat-label>
            <mat-select formControlName="resourceNameFilter">
              <mat-option value="">{{ 'solution_operation_all_resources' | translate }}</mat-option>
              <mat-option *ngFor="let resource of availableResources" [value]="resource">{{ resource }}</mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field appearance="outline" class="filter-field">
            <mat-label>{{ 'solution_operation_filter_by_justification_type' | translate }}</mat-label>
            <mat-select formControlName="typesFilter" multiple>
              <mat-option *ngFor="let type of availableProofTypes" [value]="type">{{ type }}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <ng-container *ngIf="proofRows.length > 0; else noProofRows">
          <div class="operation-table-wrapper">
            <app-table
              class="operation-table"
              [columns]="proofColumns"
              [rows]="proofRows"
              [customCellTemplates]="{
                fileName: proofFileNameCell,
                comment: proofCommentCell,
                actions: proofActionsCell
              }">
            </app-table>
          </div>
        </ng-container>
        <ng-template #noProofRows>
          <div class="operation-table-wrapper">
            <div class="empty-table">{{ 'solution_operation_no_proof' | translate }}</div>
          </div>
        </ng-template>
        <div class="add-resource-row" *ngIf="isEditable">
          <button mat-button color="accent" (click)="addMultipleProofs(operation)">
            <mat-icon>add_circle</mat-icon>
            {{ 'solution_operation_upload_proofs' | translate }}
          </button>
        </div>
      </mat-tab>
    </mat-tab-group>
  </div>
</mat-expansion-panel>
